export const CREATE_SLA = 'CREATE_SLA'
export const UPDATE_SLA = 'UPDATE_SLA'
export const FETCH_SLA_LIST = 'FETCH_SLA_LIST'
export const FETCH_SLA_SETTINGS = 'FETCH_SLA_SETTINGS'
export const UPDATE_SLA_SETTINGS = 'UPDATE_SLA_SETTINGS'


export const TOGGLE_SLA = 'TOGGLE_SLA'
export const UPDATE_SLA_ORDER = 'UPDATE_SLA_ORDER'

export const REORDER_SLA_ORDER = 'REORDER_SLA_ORDER'
export const REVERT_SLA_ORDER = 'REVERT_SLA_ORDER'